import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LOCALE, FALLBACK_NAMESPACE } from "./index";

i18n
	.use(HttpBackend)
	.use(initReactI18next)
	.init({
		lng: DEFAULT_LOCALE,
		fallbackLng: DEFAULT_LOCALE,
		ns: [
			FALLBACK_NAMESPACE,
			"documents",
			"profile",
			"onboarding",
			"feedback",
			"twoFactor",
			"session",
			"communication",
			"education",
			"journeyEmpty",
		],
		defaultNS: FALLBACK_NAMESPACE,
		fallbackNS: FALLBACK_NAMESPACE,
		debug: false,
		interpolation: {
			escapeValue: false,
		},
		backend: {
			loadPath: "/locales/{{lng}}/{{ns}}.json",
		},
		react: {
			useSuspense: false,
		},
	});

export default i18n;
